import { loadCustomColors, saveCustomColors, applyCustomColors, DEFAULT_COLORS } from '../services/colorService';
import { initEventList } from './EventList';

export function initColorManager() {
  const colorsBtn = document.getElementById('colors-btn');

  if (colorsBtn) {
    colorsBtn.addEventListener('click', showColorsModal);
  }
}

export async function showColorsModal() {
  const modal = document.getElementById('colors-modal');

  if (!modal) {
    console.error('Modale couleurs non trouvée');
    return;
  }

  const closeBtn = document.getElementById('close-colors-modal');
  const cancelBtn = document.getElementById('cancel-colors-edit');
  const resetBtn = document.getElementById('reset-colors');
  const form = document.getElementById('edit-colors-form');

  // Charger les couleurs actuelles
  const currentColors = await loadCustomColors();

  // Récupérer les éléments avec vérification
  const confirmedInput = document.getElementById('color-confirmed');
  const optionPlusInput = document.getElementById('color-option-plus');
  const optionMoinsInput = document.getElementById('color-option-moins');
  const separatorPeriodInput = document.getElementById('color-separator-period');
  const pastEventsInput = document.getElementById('color-past-events');
  const primaryColorInput = document.getElementById('color-primary');     // NOUVEAU
  const secondaryColorInput = document.getElementById('color-secondary'); // NOUVEAU

  // VÉRIFIER avant d'assigner
  if (confirmedInput) confirmedInput.value = currentColors.confirmed;
  if (optionPlusInput) optionPlusInput.value = currentColors.optionPlus;
  if (optionMoinsInput) optionMoinsInput.value = currentColors.optionMoins;
  if (separatorPeriodInput) separatorPeriodInput.value = currentColors.separatorPeriod;
  if (pastEventsInput) pastEventsInput.value = currentColors.pastEvents;
  if (primaryColorInput) primaryColorInput.value = currentColors.primaryColor;     // NOUVEAU
  if (secondaryColorInput) secondaryColorInput.value = currentColors.secondaryColor; // NOUVEAU

  // Appliquer les couleurs au preview
  updatePreview(currentColors);

  // Afficher la modale
  modal.style.display = 'flex';

  // Gestionnaire pour mettre à jour le preview en temps réel
  const updatePreviewFromInputs = () => {
    const previewColors = {
      confirmed: confirmedInput.value,
      optionPlus: optionPlusInput.value,
      optionMoins: optionMoinsInput.value,
      separatorPeriod: separatorPeriodInput.value,
      pastEvents: pastEventsInput.value,
      primaryColor: primaryColorInput.value,     // NOUVEAU
      secondaryColor: secondaryColorInput.value  // NOUVEAU
    };
    updatePreview(previewColors);
  };

  // Écouter les changements de couleur
  confirmedInput.addEventListener('input', updatePreviewFromInputs);
  optionPlusInput.addEventListener('input', updatePreviewFromInputs);
  optionMoinsInput.addEventListener('input', updatePreviewFromInputs);
  separatorPeriodInput.addEventListener('input', updatePreviewFromInputs);
  pastEventsInput.addEventListener('input', updatePreviewFromInputs);
  primaryColorInput.addEventListener('input', updatePreviewFromInputs);     // NOUVEAU
  secondaryColorInput.addEventListener('input', updatePreviewFromInputs);   // NOUVEAU

  // Gestionnaire de réinitialisation
  const handleReset = () => {
    confirmedInput.value = DEFAULT_COLORS.confirmed;
    optionPlusInput.value = DEFAULT_COLORS.optionPlus;
    optionMoinsInput.value = DEFAULT_COLORS.optionMoins;
    separatorPeriodInput.value = DEFAULT_COLORS.separatorPeriod;
    pastEventsInput.value = DEFAULT_COLORS.pastEvents;
    primaryColorInput.value = DEFAULT_COLORS.primaryColor;     // NOUVEAU
    secondaryColorInput.value = DEFAULT_COLORS.secondaryColor; // NOUVEAU
    updatePreview(DEFAULT_COLORS);
  };

  resetBtn.addEventListener('click', handleReset);

  // Gestionnaires de fermeture UNIFIÉS
  const closeModalHandler = () => {
    closeModal('colors-modal');

    // Nettoyer les event listeners
    confirmedInput.removeEventListener('input', updatePreviewFromInputs);
    optionPlusInput.removeEventListener('input', updatePreviewFromInputs);
    optionMoinsInput.removeEventListener('input', updatePreviewFromInputs);
    separatorPeriodInput.removeEventListener('input', updatePreviewFromInputs);
    pastEventsInput.removeEventListener('input', updatePreviewFromInputs);
    primaryColorInput.removeEventListener('input', updatePreviewFromInputs);     // NOUVEAU
    secondaryColorInput.removeEventListener('input', updatePreviewFromInputs);   // NOUVEAU
    resetBtn.removeEventListener('click', handleReset);
  };

  closeBtn.addEventListener('click', closeModalHandler);
  cancelBtn.addEventListener('click', closeModalHandler);

  // Fermer en cliquant en dehors
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeModalHandler();
    }
  });

  // Gestionnaire de soumission du formulaire
  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    try {
      const newColors = {
        confirmed: confirmedInput.value,
        optionPlus: optionPlusInput.value,
        optionMoins: optionMoinsInput.value,
        separatorPeriod: separatorPeriodInput.value,
        pastEvents: pastEventsInput.value,
        primaryColor: primaryColorInput.value,     // NOUVEAU
        secondaryColor: secondaryColorInput.value  // NOUVEAU
      };

      // Sauvegarder les nouvelles couleurs
      await saveCustomColors(newColors);

      // Appliquer les nouvelles couleurs globalement
      applyCustomColors(newColors);

      // Rafraîchir l'affichage des événements
      await initEventList();

      // Fermer la modale
      closeModalHandler();

      // Notification de succès
      showNotification('Couleurs mises à jour avec succès', 'success');

    } catch (error) {
      console.error('Erreur lors de la mise à jour des couleurs:', error);
      showNotification('Une erreur est survenue lors de la mise à jour des couleurs', 'error');
    }
  });
}

// Fonction pour mettre à jour le preview
function updatePreview(colors) {
  const root = document.documentElement;

  // Appliquer temporairement les couleurs pour le preview
  root.style.setProperty('--confirmed-color', colors.confirmed);
  root.style.setProperty('--option-plus-color', colors.optionPlus);
  root.style.setProperty('--option-moins-color', colors.optionMoins);
  root.style.setProperty('--separator-period-color', colors.separatorPeriod);
  root.style.setProperty('--past-background', colors.pastEvents);
  root.style.setProperty('--primary-color', colors.primaryColor);     // NOUVEAU
  root.style.setProperty('--secondary-color', colors.secondaryColor); // NOUVEAU
}

// Fonction pour afficher les notifications
function showNotification(message, type = 'info') {
  const notification = document.createElement('div');
  notification.className = `notification ${type}`;
  notification.textContent = message;

  notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    padding: 12px 20px;
    border-radius: 4px;
    color: white;
    font-weight: 500;
    z-index: 10000;
    transform: translateX(100%);
    transition: transform 0.3s ease;
    ${type === 'success' ? 'background-color: #4caf50;' : ''}
    ${type === 'error' ? 'background-color: #f44336;' : ''}
    ${type === 'info' ? 'background-color: #2196f3;' : ''}
  `;

  document.body.appendChild(notification);

  // Animation d'entrée
  setTimeout(() => {
    notification.style.transform = 'translateX(0)';
  }, 100);

  // Animation de sortie et suppression
  setTimeout(() => {
    notification.style.transform = 'translateX(100%)';
    setTimeout(() => {
      if (notification.parentNode) {
        document.body.removeChild(notification);
      }
    }, 300);
  }, 3000);
}